import { FunctionalComponent } from 'preact';
import { route } from 'preact-router';
import { nav } from '##/init';
import { logout } from '##/services/authentication/Authentication';

export const Redirect: FunctionalComponent<{ to: string }> = (props) => {
  if (props.path === '/sign-out') {
    nav.onKeyEvent('RIGHT'); // Workaround for "Sign Out" text persisting on sign out click
    logout();
  }
  route(props.to);
  return <></>;
};
